<template>
  <div>
    <div class="md:flex justify-end"></div>
    <CommonDataTable :keySearch="keySearch" class="mt-4" />
  </div>
</template>
<script>
import CommonDataTable from "../../../screens/adminScreen/common/CommonDataTable";
export default {
  data() {
    return { keySearch: "" };
  },
  components: { CommonDataTable },
};
</script>
